var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCopyFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53839 6.07714C3.53839 4.31836 4.44955 3.408 6.18075 3.408H11.6356V3.25318C11.6356 1.97744 10.9917 1.33337 9.72821 1.33337H3.24074C1.96511 1.33337 1.33337 1.97744 1.33337 3.25318V9.76812C1.33337 11.05 1.96511 11.6879 3.24074 11.6879H3.53839V6.07714ZM6.27187 14.6667H12.7593C14.0289 14.6667 14.6667 14.0288 14.6667 12.7531V6.17004C14.6667 4.8943 14.0289 4.25023 12.7593 4.25023H6.27187C5.00232 4.25023 4.36451 4.8943 4.36451 6.17004V12.7531C4.36451 14.0288 5.00232 14.6667 6.27187 14.6667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyFull);
export default __webpack_public_path__ + "static/media/icon-copy-full.cf88277a61d646c47e9c1f9d641ffece.svg";
export { ForwardRef as ReactComponent };